var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"user-select":"none"},on:{"mouseout":_vm.mouseOut,"mouseover":_vm.mouseOver}},[_c('vue-p5',{on:{"sketch":_vm.sketch,"setup":_vm.setup,"draw":_vm.draw,"~mousepressed":function($event){return _vm.handleUserInteraction($event)},"~keypressed":function($event){return _vm.handleUserInteraction($event)},"mousemoved":_vm.mouseMoved}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1fe90a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DotCloud.vue
// module id = null
// module chunks = 